import { warn } from 'styles/colorProvider';

export const formatAgentStatus = (status) => {
    if (!status) return;
    if (status === 'created') return { label: 'Em análise', color: warn };
};
